import React, { useEffect, useRef } from 'react';
import * as d3 from 'd3';
import cloud from 'd3-cloud';

const WordCloud = ({ words }) => {
    const svgRef = useRef(null);

    useEffect(() => {
        if (!svgRef.current) return;
        const svg = d3.select(svgRef.current);
        const width = 800; 
        const height = 600; 
        svg.attr('width', width).attr('height', height);
        const minFontSize = 30; 
        const maxFontSize = 60; 
        const valueExtent = d3.extent(words, (d) => d.count) || [0, 1]; 
        const fontSizeScale = d3
            .scaleLinear()
            .domain(valueExtent)
            .range([minFontSize, maxFontSize]);

        const layout = cloud()
            .size([width, height])
            .words(
                words.map((d) => ({
                    text: d.hashtag, 
                    size: fontSizeScale(d.count), 
                }))
            )
            .padding(2) 
            .rotate(() => (Math.random() > 0.5 ? 0 : 90)) 
            .font('Impact')
            .fontSize((d) => d.size)
            .on('end', draw);

        layout.start();

        function draw(words) {
            const group = svg
                .append('g')
                .attr('transform', `translate(${width / 2},${height / 2})`);

            group
                .selectAll('text')
                .data(words)
                .enter()
                .append('text')
                .style('font-size', (d) => `${d.size}px`)
                .style('font-family', 'Impact')
                .attr('text-anchor', 'middle')
                .attr('transform', (d) => `translate(${d.x},${d.y})rotate(${d.rotate})`)
                .attr('opacity', 0) 
                .text((d) => d.text) 
                .attr('fill', (d) => d3.interpolateRainbow(d.size / maxFontSize)) 
                .transition()
                .duration(1000)
                .attr('opacity', 2); 
        }
    }, [words]);

    return (
        <div>
            <svg ref={svgRef} />
        </div>
    );
};

export default WordCloud;